<template>
  <div class="addr-component">
    <div class="addr-main" @click.stop="$emit('on-click')">
      <div class="addr-info">
        <div class="contact-info">
          <div class="addr-name">{{value.receive_name}}</div>
          <div class="addr-mobile">+{{value.state_code + ' ' + value.receive_tel}}</div>
        </div>
        <div class="address">
          {{value.area_info}} {{value.address}}
        </div>
        <div class="postcode" v-if="value.postcode">
          {{value.postcode}}
        </div>
      </div>
      <div class="addr-right-info">
        <div class="addr-default" v-show="value.is_default">{{$t('addr.value_def')}}</div>
        <slot name="action-order"></slot>
      </div>
    </div>

    <div class="addr-footer">
      <span class="default-set">
        {{$t('addr.label_addr_def')}}：<iSwitch v-model="value.is_default" :disabled="loading" @on-change="onChangeDefault"/>
      </span>
      <slot name="action"></slot>
    </div>
  </div>
</template>

<script>
    export default {
        name: 'MyAddr',
        props: {
            value: Object,
            loading: {
                type: Boolean,
                default: false
            }
        },
        methods: {
            onChangeDefault: function (isDefault) {
                this.$emit('on-change-default', isDefault)
            }
        }
    }
</script>
